export default __webpack_public_path__ + "static/media/vtcmarketingbanner-1.0caec658.png";